/**
 * Optimized Interview Management Sidebar Component
 * Contains tabs and filters for better organization
 */

import React, { memo } from 'react';
import InterviewFilters from './InterviewFilters';

const InterviewManagementSidebar = memo(({
  tabs,
  activeTab,
  onTabChange,
  filters,
  onFilterChange,
  onClearFilters,
  hasActiveFilters,
  viewMode,
  onViewModeChange
}) => {
  return (
    <div className="md:w-64 lg:w-72 shrink-0">
      {/* Sidebar Tabs */}
      <div className="mb-6 bg-white rounded-lg border border-border p-2 top-20">
        <h3 className="font-semibold text-md mb-2 px-2">Interview Status</h3>
        <div className="flex flex-col">
          {tabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`px-3 py-2 rounded-md mb-1 font-medium text-sm text-left transition-colors duration-200 flex justify-between items-center ${
                activeTab === tab.id 
                  ? 'bg-primary-50 text-primary' 
                  : 'hover:bg-gray-100 text-text-secondary'
              }`}
            >
              <span>{tab.label}</span>
              <span className="px-1.5 py-0.5 text-xs rounded-full bg-background border border-border">
                {tab.count || 0}
              </span>
            </button>
          ))}
        </div>
      </div>
      
      {/* Sidebar Filters */}
      <div className="sticky top-64">
        <InterviewFilters 
          filters={filters} 
          onFilterChange={onFilterChange} 
          onClearFilters={onClearFilters} 
          hasActiveFilters={hasActiveFilters} 
          viewMode={viewMode}
          setViewMode={onViewModeChange}
          isSidebar={true}
        />
      </div>
    </div>
  );
});

InterviewManagementSidebar.displayName = 'InterviewManagementSidebar';

export default InterviewManagementSidebar;